import { loadStripe } from '@stripe/stripe-js';
import type { StripeElementsOptions } from '@stripe/stripe-js';

const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_STRIPE_PUBLIC_KEY;

export const isStripeConfigured = Boolean(stripePublishableKey);

let stripePromise: ReturnType<typeof loadStripe> | null = null;

export const getStripePromise = () => {
  if (!stripePublishableKey) return null;

  if (!stripePromise) {
    stripePromise = loadStripe(stripePublishableKey);
  }

  return stripePromise;
};

export const stripeAppearance: NonNullable<StripeElementsOptions['appearance']> = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#111111',
    colorText: '#171717',
    colorDanger: '#cf1322',
    colorBackground: '#ffffff',
    colorTextPlaceholder: '#9a9a9a',
    borderRadius: '14px',
    spacingUnit: '5px',
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  },
  rules: {
    '.Tab': {
      border: '1px solid #e5e5e5',
      backgroundColor: '#fafafa',
    },
    '.Tab--selected': {
      backgroundColor: '#ffffff',
      borderColor: '#111111',
    },
    '.Block': {
      backgroundColor: '#ffffff',
      border: '1px solid #e8e8e8',
      boxShadow: 'none',
    },
    '.Input': {
      border: '1px solid #e3e3e3',
      boxShadow: 'none',
    },
    '.Input:focus': {
      borderColor: '#111111',
      boxShadow: '0 0 0 1px #111111',
    },
    '.Label': {
      fontWeight: '500',
    },
  },
};
